import Jwt from '../helper/interceptors';
import { AppSettings } from '../constants';
import { ObjToParam, MapResponse } from '../helper/helper-api';

// BEGIN SUBCONTRACTOR
export const getSubcontractorPurchaseOrderList = params => {
  return Jwt(AppSettings.GLOBAL_API_URL, true, {
    headers: [{ key: 'Key', value: params.rfsId }]
  })
    .get(
      `/apiv1/request-for-services/work-orders/purchases?${ObjToParam(
        params.data
      )}`
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getSubcontractorPurchaseOrderDetail = params => {
  return Jwt(AppSettings.GLOBAL_API_URL, true, {
    headers: [{ key: 'Key', value: params.refNo }]
  })
    .get(
      `/apiv1/request-for-services/work-orders/${params.WOID}/purchases/${params.refNo}`,
      params.data
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const printPreviewSubcontractorPurchaseOrder = params => {
  return Jwt(null, true) // {headers: [{key: params.headers.key, value: params.headers.value}]}
    .get(`${params.printPOEndpoint}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};
// END SUBCONTRACTOR

export const getPurchaseOrderList = params => {
  return Jwt(AppSettings.GLOBAL_API_URL, false, {
    headers: [{ key: 'Key', value: params.rfsId }]
  })
    .get(`/apiv1/purchase-orders/search?${ObjToParam(params.data)}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getPurchaseOrderDetail = params => {
  return Jwt(AppSettings.GLOBAL_API_URL, true, {
    headers: [{ key: 'Key', value: params.refNo }]
  })
    .get(`/apiv1/purchase-orders/${params.refNo}`, {})
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const createPurchaseOrder = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false, {
    headers: [{ key: 'Key', value: params.rfsId }]
  })
    .post('/api/purchase-orders', params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const editPurchaseOrder = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false, {
    headers: [{ key: 'Key', value: params.refNo }]
  })
    .put(`/api/purchase-orders/${params.refNo}`, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const resendPurchaseOrder = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false, {
    headers: [{ key: 'Key', value: params.refNo }]
  })
    .put(`/api/purchase-orders/${params.refNo}/notify`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const purchaseOrderAttachments = params => {
  return Jwt(AppSettings.GLOBAL_API_URL, false, {
    headers: [{ key: 'Key', value: params.refNo }]
  })
    .post(
      `/apiv1/request-for-services/purchase-orders/${params.refNo}/attachments`,
      params.data
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const printPreviewPurchaseOrder = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .get(`/api/purchase-orders/print-preview/${params.refNo}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};



// WEBPACK FOOTER //
// ./src/Purchase-Orders/api.js